import { useEffect, useState } from "react";
import useSelect2 from "../../hooks/useSelect2";
import Cookies from "js-cookie";

export default function Country({countryButton, searchCountry, searchState, searchCity}) {
 // console.log(searchCity)
 const token = JSON.parse(decodeURIComponent(Cookies.get("authTokenUserLogin") || Cookies.get("authTokenUser") || null));
  const [country, setCountry] = useState([])
  const [state, setState] = useState([])
  const [city, setCity] = useState([])
  const [selectedCountry, setSelectedCountry] = useState(searchCountry)
  const [selectedState, setSelectedState] = useState(searchState)
  const [selectedCity, setSelectedCity] = useState(searchCity)

  
  const fetchCountry = async () => {

  const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/country`, {
        method: "GET",
        headers: { "Content-Type": "application/json",
          
         },
        });

      const data = await res.json();
      if(data.status){

        setCountry(data.data)
      }
}
const fetchState = async (id) => {
  
  const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/state-multi`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
         },
        body:JSON.stringify({country:[selectedCountry]})
        });

      const data = await res.json();
      if(data.status){

        setState(data.data)
      } else {
        setState(data.data)
      }
}
const fetchCity = async (id) => {

  const res = await fetch(`${process.env.REACT_APP_BASE_URL_API}/api/front/city-multi`, {
        method: "POST",
        headers: { "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
         },
        body:JSON.stringify({state:[selectedState]})
        });

      const data = await res.json();
      if(data.status){

        setCity(data.data)
      } else {
        setCity(data.data)
      }
}


useEffect(() => {

fetchCountry()

 }, [])

 useEffect(() => {
  
  if(selectedCountry)
    
    fetchState()
    setCity([])
  countryButton(selectedCountry, 'country')
}, [selectedCountry])

useEffect(() => {
  
  if(selectedState)
  fetchCity()
  countryButton(selectedState, 'state')
}, [selectedState])

useEffect(() => {
  
  if(selectedCity)
  countryButton(selectedCity, 'city')
}, [selectedCity])
  
  
  useSelect2(".inline-multiselectC4", {
    placeholder: "All",
    closeOnSelect: false
  }, setSelectedCountry);
  useSelect2(".inline-multiselectC5", {
    placeholder: "All",
    closeOnSelect: false
  }, setSelectedState);
  useSelect2(".inline-multiselectC6", {
    placeholder: "All",
    closeOnSelect: false
  }, setSelectedCity);

  return (
    
    
    <>
    
    <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo5"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            <img src='assets/img/locationn.png' alt='' /> Country
                          </button>
                        </h2>
                        <div
                          id="collapseTwo5"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#myAccordion"
                        >
                          <div className="accordion-body">
                            {/* start */}
                            <select
                              className="inline-multiselect inline-multiselectC4"
                              search={false}
                              value={selectedCountry}
                            >
                              <option value=" ">All</option>
                              {country && country.map((countryList, index)  => {

                                        return (

                                            <option value={countryList._id}>{countryList.name}</option>
                                        )

                                    })
                                    }
                            </select>
                            {/* end */}
                          </div>
                        </div>
                      </div>
                      {/* item end */}
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo6"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            <img src='assets/img/state.png' alt='' /> State
                          </button>
                        </h2>
                        <div
                          id="collapseTwo6"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#myAccordion"
                        >
                          <div className="accordion-body">
                            {/* start */}
                            <select
                            className="inline-multiselect inline-multiselectC5"
                           
                            value={selectedState}
                          >
                            <option value=" ">All</option>
                            {state && state.map((stateList, index)  => {

                                        return (

                                            <option value={stateList._id}>{stateList.name}</option>
                                        )

                                    })
                                    }
                          </select>
                            {/* end */}
                          </div>
                        </div>
                      </div>
                      {/* item end */}
                      <div className="accordion-item">
                        <h2 className="accordion-header" id="headingTwo">
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target="#collapseTwo7"
                            aria-expanded="false"
                            aria-controls="collapseTwo"
                          >
                            <img src='assets/img/district.png' alt='' /> District/City
                          </button>
                        </h2>
                        <div
                          id="collapseTwo7"
                          className="accordion-collapse collapse"
                          aria-labelledby="headingTwo"
                          data-bs-parent="#myAccordion"
                        >
                          <div className="accordion-body">
                            {/* start */}
                            <select
                            className="inline-multiselect inline-multiselectC6"
                            
                            value={selectedCity}
                          >
                            <option value=" ">All</option>
                            {city && city.map((cityList, index)  => {

                                        return (

                                            <option value={cityList._id}>{cityList.name}</option>
                                        )

                                    })
                                    }
                          </select>
                            {/* end */}
                          </div>
                        </div>
                      </div>
    </>
    
    
    
    
  );
}
